export const MongoConsoleNavigation = {
    MongoConsolePage: '/admin/mongo-console'
};
